import { SET_CURRENT_PROPERTIES_PAGE } from '../constants';

export const actionSetCurrentPropertiesPage = currentPage => {
  return async dispatch => {
    dispatch({ type: SET_CURRENT_PROPERTIES_PAGE, currentPage });
  };
};

export default actionSetCurrentPropertiesPage;
